import { useDispatch, useSelector } from "react-redux";
import { setFilterAcceptsReservations } from "../../../store";
import { Box, Checkbox } from "@mui/joy";

function FilterReservation() {
  const dispatch = useDispatch();
  const filterValue = useSelector((state) => state.filter.acceptsReservations);
  const selectedOption = filterValue === null ? false : true;
  return (
    <Box>
      <Checkbox
        label="Takes Reservations"
        checked={selectedOption}
        onChange={(event) => {
          if (event.target.checked) {
            dispatch(setFilterAcceptsReservations(true));
          } else {
            dispatch(setFilterAcceptsReservations(null));
          }
        }}
      />
    </Box>
  );
}

export default FilterReservation;
